export type AutoRefillMainTab = 'schedule_list' | 'add_schedule';
export type AutoRefillAddSubView = 'search' | 'profile';

export interface AutoRefillPharmacyOption {
  id: number;
  label: string;
}

export interface AutoRefillFreqPreset {
  id: string;
  label: string;
}

export const AUTO_REFILL_PHARMACY_OPTIONS: AutoRefillPharmacyOption[] = [
  { id: 26, label: 'Adelaide Pharmacy' },
  { id: 3, label: 'Advantage Care Pharmacy' }
];

export const AUTO_REFILL_FREQ_PRESETS: AutoRefillFreqPreset[] = [
  { id: 'Q1D (Daily)', label: 'Q1D (Daily)' },
  { id: 'Q7D (Every 7 days)', label: 'Q7D (Every 7 days)' },
  { id: 'Q1M (Monthly)', label: 'Q1M (Monthly)' },
  { id: 'Custom', label: 'Custom' }
];

export const AUTO_REFILL_RX_PAGE_SIZE = 10;
export const AUTO_REFILL_PATIENT_PAGE_SIZE = 20;
